// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__EcJOo","avatar":"style_avatar__292KC"};